import React from 'react'
import WaterAccessManager from '../WaterAccess/WaterAccessManager'

const SubcontractorWaterAccess = () => {
  return (
    <WaterAccessManager
      apiBase="/api/subcontractor/water-access"
      canEdit={true}
      showNearMe={true}
    />
  )
}

export default SubcontractorWaterAccess
